/* =========================================================
   ES: Disable tooltips site-wide
   - Removes native browser "title" tooltips
   - Disposes Bootstrap/jQuery tooltips & popovers if present
   - Watches dynamically injected DOM (mini cart, quickview, etc.)
   - Optimized to avoid heavy full-document work on every mutation
   - Hardened for BFCache / repeated runtime bootstraps
   ========================================================= */
(function () {
  "use strict";

  if (window.__esDisableTooltipsCleanup) {
    try { window.__esDisableTooltipsCleanup(); } catch (e) {}
  }

  var observer = null;
  var scheduled = false;
  var pending = [];
  var pendingSeen = typeof WeakSet === 'function' ? new WeakSet() : null;
  var needsDispose = false;
  var rafId = 0;
  var domReadyHandler = null;
  var mouseOverHandler = null;
  var focusInHandler = null;
  var pageShowHandler = null;
  var pageHideHandler = null;

  function ensureAriaLabel(el, title) {
    try {
      if (!el.getAttribute("aria-label") && title && title.trim()) {
        el.setAttribute("aria-label", title.trim());
      }
    } catch (e) {}
  }

  function stripTitle(el) {
    try {
      if (!el || el.nodeType !== 1) return;
      var title = el.getAttribute("title");
      if (title == null) return;
      ensureAriaLabel(el, title);
      el.setAttribute("data-es-title", title);
      el.removeAttribute("title");
    } catch (e) {}
  }

  function stripBootstrapTooltipAttrs(el) {
    try {
      if (!el || el.nodeType !== 1) return;
      var dt = el.getAttribute("data-toggle");
      if (dt === "tooltip" || dt === "popover") el.removeAttribute("data-toggle");
      var dbt = el.getAttribute("data-bs-toggle");
      if (dbt === "tooltip" || dbt === "popover") el.removeAttribute("data-bs-toggle");
      el.removeAttribute("data-original-title");
      el.removeAttribute("data-bs-original-title");
      el.removeAttribute("aria-describedby");
    } catch (e) {}
  }

  function hasTooltipCandidates(root) {
    try {
      if (!root || root.nodeType !== 1) return false;
      if (root.hasAttribute && (
        root.hasAttribute('title') ||
        root.getAttribute('data-toggle') === 'tooltip' ||
        root.getAttribute('data-toggle') === 'popover' ||
        root.getAttribute('data-bs-toggle') === 'tooltip' ||
        root.getAttribute('data-bs-toggle') === 'popover'
      )) return true;
      return !!(
        root.querySelector &&
        root.querySelector('[title],[data-toggle="tooltip"],[data-toggle="popover"],[data-bs-toggle="tooltip"],[data-bs-toggle="popover"]')
      );
    } catch (e) {
      return false;
    }
  }

  function process(root) {
    try {
      if (!root) root = document;
      if (root.querySelectorAll) {
        var titled = root.querySelectorAll("[title]");
        for (var i = 0; i < titled.length; i++) stripTitle(titled[i]);
        var bs = root.querySelectorAll(
          '[data-toggle="tooltip"],[data-toggle="popover"],[data-bs-toggle="tooltip"],[data-bs-toggle="popover"]'
        );
        for (var j = 0; j < bs.length; j++) stripBootstrapTooltipAttrs(bs[j]);
      } else if (root.nodeType === 1) {
        stripTitle(root);
        stripBootstrapTooltipAttrs(root);
      }
    } catch (e) {}
  }

  function disposeFrameworkTooltips() {
    try {
      if (window.bootstrap && window.bootstrap.Tooltip) {
        var els = document.querySelectorAll('[data-bs-toggle="tooltip"],[data-toggle="tooltip"]');
        for (var i = 0; i < els.length; i++) {
          try {
            var inst = window.bootstrap.Tooltip.getInstance(els[i]);
            if (inst) inst.dispose();
          } catch (e) {}
        }
      }
      if (window.bootstrap && window.bootstrap.Popover) {
        var els2 = document.querySelectorAll('[data-bs-toggle="popover"],[data-toggle="popover"]');
        for (var j = 0; j < els2.length; j++) {
          try {
            var inst2 = window.bootstrap.Popover.getInstance(els2[j]);
            if (inst2) inst2.dispose();
          } catch (e) {}
        }
      }
    } catch (e) {}

    try {
      if (window.jQuery && window.jQuery.fn) {
        var $ = window.jQuery;
        if ($.fn.tooltip) {
          try { $('[data-toggle="tooltip"]').tooltip('dispose'); } catch (e) {}
        }
        if ($.fn.popover) {
          try { $('[data-toggle="popover"]').popover('dispose'); } catch (e) {}
        }
      }
    } catch (e) {}
  }

  function remember(node) {
    if (!node) return;
    if (pendingSeen) {
      if (pendingSeen.has(node)) return;
      pendingSeen.add(node);
    }
    pending.push(node);
  }

  function clearScheduled() {
    if (rafId) {
      try { (window.cancelAnimationFrame || clearTimeout)(rafId); } catch (e) {}
      rafId = 0;
    }
    scheduled = false;
  }

  function flush() {
    rafId = 0;
    scheduled = false;
    if (!pending.length && !needsDispose) return;
    var work = pending.slice(0);
    pending.length = 0;
    pendingSeen = typeof WeakSet === 'function' ? new WeakSet() : null;
    for (var i = 0; i < work.length; i++) process(work[i]);
    if (needsDispose) {
      needsDispose = false;
      disposeFrameworkTooltips();
    }
  }

  function schedule(node, shouldDispose) {
    if (node) remember(node);
    if (shouldDispose) needsDispose = true;
    if (scheduled) return;
    scheduled = true;
    rafId = (window.requestAnimationFrame || function (cb) { return setTimeout(cb, 16); })(flush);
  }

  function disconnectObserver() {
    if (!observer) return;
    try { observer.disconnect(); } catch (e) {}
    observer = null;
  }

  function connectObserver() {
    if (observer || !window.MutationObserver) return;
    var moRoot = document.body || document.documentElement;
    if (!moRoot) return;

    observer = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (m.type === 'attributes') {
          if (m.target && hasTooltipCandidates(m.target)) schedule(m.target, true);
          continue;
        }
        if (!m.addedNodes) continue;
        for (var j = 0; j < m.addedNodes.length; j++) {
          var node = m.addedNodes[j];
          if (!node || node.nodeType !== 1) continue;
          if (node.tagName === 'SCRIPT' || node.tagName === 'STYLE' || node.tagName === 'LINK') continue;
          if (!hasTooltipCandidates(node)) continue;
          schedule(node, true);
        }
      }
    });

    observer.observe(moRoot, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['title', 'data-toggle', 'data-bs-toggle', 'data-original-title', 'data-bs-original-title']
    });
  }

  function boot() {
    process(document);
    disposeFrameworkTooltips();
    connectObserver();
  }

  mouseOverHandler = function (e) {
    var el = e.target && e.target.closest ? e.target.closest("[title]") : null;
    if (el) stripTitle(el);
  };
  document.addEventListener("mouseover", mouseOverHandler, true);

  focusInHandler = function (e) {
    var el = e.target && e.target.closest ? e.target.closest("[title]") : null;
    if (el) stripTitle(el);
  };
  document.addEventListener("focusin", focusInHandler, true);

  domReadyHandler = boot;
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", domReadyHandler);
  } else {
    boot();
  }

  pageShowHandler = function () {
    boot();
    schedule(document.body || document.documentElement, true);
  };
  window.addEventListener('pageshow', pageShowHandler);

  pageHideHandler = function () {
    disconnectObserver();
    clearScheduled();
    pending.length = 0;
    pendingSeen = typeof WeakSet === 'function' ? new WeakSet() : null;
    needsDispose = false;
  };
  window.addEventListener('pagehide', pageHideHandler);

  window.__esDisableTooltipsCleanup = function () {
    disconnectObserver();
    clearScheduled();
    pending.length = 0;
    pendingSeen = typeof WeakSet === 'function' ? new WeakSet() : null;
    needsDispose = false;
    if (domReadyHandler) document.removeEventListener('DOMContentLoaded', domReadyHandler);
    if (mouseOverHandler) document.removeEventListener('mouseover', mouseOverHandler, true);
    if (focusInHandler) document.removeEventListener('focusin', focusInHandler, true);
    if (pageShowHandler) window.removeEventListener('pageshow', pageShowHandler);
    if (pageHideHandler) window.removeEventListener('pagehide', pageHideHandler);
  };
})();
